"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainPoints = void 0;
var dateRangeStepToMillis_1 = require("./dateRangeStepToMillis");
var model_1 = require("./model");
function getDomainPoints(domain) {
    if (!domain || Array.isArray(domain))
        return domain;
    if (model_1.isValueRange(domain))
        return getValueRangeDomainPoints(domain);
    else
        return getDateRangeDomainPoints(domain);
}
exports.getDomainPoints = getDomainPoints;
function getValueRangeDomainPoints(domain) {
    var _a;
    var points = [];
    var step = (_a = domain.step) !== null && _a !== void 0 ? _a : 1;
    for (var i = domain.init; i <= domain.end; i += step)
        points.push(i);
    if (!points.includes(domain.end))
        points.push(domain.end);
    return points;
}
function getDateRangeDomainPoints(domain) {
    var _a;
    var points = [];
    var step = (_a = domain.step) !== null && _a !== void 0 ? _a : { amount: 1, unit: 'day' };
    var endMillis = +domain.end;
    var currValue = +domain.init;
    do {
        points.push(currValue.valueOf());
        currValue = addStepToDate(currValue, step);
    } while (currValue < endMillis);
    if (!points.includes(endMillis))
        points.push(domain.end.valueOf());
    return points;
}
function addStepToDate(dateMillis, step) {
    switch (step.unit) {
        case 'year':
            var newDateY = new Date(dateMillis);
            newDateY.setFullYear(newDateY.getFullYear() + step.amount);
            return +newDateY;
        case 'month':
            var newDateM = new Date(dateMillis);
            newDateM.setMonth(newDateM.getMonth() + step.amount);
            return +newDateM;
        default:
            return dateMillis + dateRangeStepToMillis_1.dateRangeStepToMillis(step);
    }
}
//# sourceMappingURL=getDomainPoints.js.map